import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import Select from 'react-select';

const AddItemSubCat = ({ show, onClose, onCreated  ,refresh ,onSuccess}) => { 
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [categories, setCategories] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [existingNameError, setExistingNameError] = useState(false);
    const [serverErrorMessage, setServerErrorMessage] = useState('');

    useEffect(() => {
        if (show) {
            axios.get(`${baseURL}/item-categories/items/active`)
                .then(res => {
                    const data = Array.isArray(res.data) ? res.data : res.data.data;
                    const mapped = data.map(cat => ({
                        value: cat.sno,
                        label: cat.itemcategory_name
                    }));
                    setCategories(mapped);
                })
                .catch(err => {
                    console.error("Error fetching categories", err);
                });
        }
    }, [show]);

    const capitalizeFirstLetter = (str) => {
        return str.replace(/\b\w/g, char => char.toUpperCase());
    };

    const handleSubmit = () => {
        setErrors({});
        setExistingNameError(false);
        setServerErrorMessage('');

        const sanitizedName = name.trim();
        const sanitizedDescription = description.trim();

        const nameTooLong = sanitizedName.length > 300;
        const descTooLong = sanitizedDescription.length > 500;

        const nameRegex = /^[A-Za-z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
        const numberRegex = /\d/;

        if (!selectedOption || !sanitizedName || nameTooLong || descTooLong) {
            setErrors({
                itemcategory_id: !selectedOption ? 'Item Category is required' : '',
                itemsubcategory_name: !sanitizedName
                    ? 'Subcategory name is required'
                    : nameTooLong
                    ? 'Subcategory name should be 300 characters max.'
                    : '',
                description: descTooLong ? 'Description should be 500 characters max.' : ''
            });
            return;
        }

        if (!nameRegex.test(sanitizedName)) {
            setErrors({ itemsubcategory_name: 'Subcategory name contains invalid characters' });
            return;
        }

        if (numberRegex.test(sanitizedName)) {
            setErrors({ itemsubcategory_name: 'Subcategory name should not contain numbers' });
            return;
        }

        const finalName = capitalizeFirstLetter(sanitizedName);
        const finalDescription = capitalizeFirstLetter(sanitizedDescription);

        axios.post(`${baseURL}/item-subcategories`, {
            itemcategory_id: selectedOption.value,
            itemsubcategory_name: finalName,
            description: finalDescription
        })
            .then(() => {
                onClose();
                if (onCreated) onCreated();
                if (onSuccess) onSuccess();
            })
            .catch(err => {
                if (err.response?.status === 409) {
                    setExistingNameError(true);
                    setServerErrorMessage(err.response.data.message || 'Item Subcategory already exists');
                } else if (err.response?.status === 400) {
                    setErrors(err.response.data.errors || {});
                } else {
                    console.error("Add failed:", err);
                }
            }); 
    };

    return (
        <Modal show={show} onHide={onClose} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Item Sub Category</h3>
                    <Button variant="" className="close px-6 py-2" onClick={onClose}> 
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Item Category <span className="required">*</span>
                            </label>
                            <Select
                                placeholder='Select Item Category'
                                value={selectedOption}
                                onChange={setSelectedOption}
                                options={categories}
                                classNamePrefix="react-select"
                            />
                            {errors.itemcategory_id && (
                                <div className="text-danger">{errors.itemcategory_id}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Item Sub Category <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.itemsubcategory_name ? 'is-invalid' : ''}`}
                                placeholder="Enter Item Sub Category"
                                value={name}
                                maxLength={300}
                                onChange={e => {
                                    const inputValue = e.target.value;
                                    const lettersOnly = inputValue.replace(/[^A-Za-z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
                                    setName(capitalizeFirstLetter(lettersOnly));
                                }}
                            />
                            {errors.itemsubcategory_name && (
                                <div className="invalid-feedback">{errors.itemsubcategory_name}</div>
                            )}
                            {existingNameError && serverErrorMessage && (
                                <div className="text-danger">{serverErrorMessage}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className="form-control"
                                placeholder="Description"
                                value={description}
                                maxLength={500}
                                onChange={e => setDescription(capitalizeFirstLetter(e.target.value))}
                            />
                            {errors.description && (
                                <div className="text-danger">{errors.description}</div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
                        <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
                        <Button variant="primary" size="sm" onClick={handleSubmit}>Create Item Sub Category</Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}; 

export default AddItemSubCat;
